import { lazy } from "react";
import { useNavigate } from "react-router-dom-v5-compat";

import { Box, Button, Stack, Text } from "@seneca/senekit";

import { getAppName } from "features/common/utils/functions/app";
import { ROUTES } from "routing/routes";

import { SignUpCard, SignUpHeading } from "../../Layout";

const SignedInAnimation = lazy(
  () =>
    import(/* webpackChunkName: "signed-in-animation" */ "./SignedInAnimation")
);

export default function SignedInCard() {
  const navigate = useNavigate();

  const navigateToParentDashboard = () => navigate(ROUTES.PARENT.buildPath({}));

  return (
    <SignUpCard>
      <Box
        component="form"
        height="100%"
        display="flex"
        flexDirection="column"
        justifyContent="space-between"
      >
        <Box width="100%" marginBottom="xxlarge">
          <Stack align="center" space="xxlarge">
            <Stack align="center" space="xlarge">
              <SignUpHeading>You're good to go!</SignUpHeading>

              <SignedInAnimation />

              <Text>
                We’ve successfully logged you in. Click below to get started.
              </Text>
            </Stack>

            <Button onClick={navigateToParentDashboard}>
              Continue to {getAppName()}
            </Button>
          </Stack>
        </Box>
      </Box>
    </SignUpCard>
  );
}
